// Model
import { Avoidability, Disposition, POST_REVISION_AVOIDABILITY_CONFIG, POST_REVISION_DISPOSITION_CONFIG, PostRevisionBadge } from "../model/post-revision-badge.model";

/**
 * Variables object returned by the rules API.
 */
export interface PostRevisionVariablesDTO {
    disposition?: string | null;
    avoidability?: string | null;
}

/**
 * Builds post-revision badges from API variables.
 *
 * - Only known disposition values are rendered.
 * - Avoidability is optional; undefined values are ignored.
 * - Unknown strings are safely skipped.
 */
export function buildPostRevisionBadges(
    variables?: PostRevisionVariablesDTO | null
): PostRevisionBadge[] {
    const badges: PostRevisionBadge[] = [];
    if (!variables) return badges;

    const disposition = variables.disposition as Disposition | undefined;
    const avoidability = variables.avoidability as Avoidability | undefined;

    const dispCfg = disposition ? POST_REVISION_DISPOSITION_CONFIG[disposition] : undefined;
    if (dispCfg) badges.push(dispCfg);

    const avoidCfg = avoidability ? POST_REVISION_AVOIDABILITY_CONFIG[avoidability] : undefined;
    if (avoidCfg) badges.push(avoidCfg);

    return badges;
}

